import React, { useEffect, useState } from 'react';
import { cpfCnpjMask } from './utils';
import { getUfs, getMunicipiosUfId, addCliente } from '../services/api';
import Toast from '../components/Toast';
import { formatarCelular } from '../utils/functions';


const CadClienteSimpl = ({ isOpen, onClose, onSuccess }) => {
    const [nome, setNome] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [celular, setCelular] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [bairro, setBairro] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [uf, setUf] = useState('');
    const [ufs, setUfs] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [toast, setToast] = useState({ message: '', type: '' });
    const [showInscricaoEstadual, setShowInscricaoEstadual] = useState(false);

    useEffect(() => {
        if (toast.message) {
            const timer = setTimeout(() => setToast({ message: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    useEffect(() => {
        const fetchUfs = async () => {
            try {
                const ufsData = await getUfs();
                if (Array.isArray(ufsData.data)) {
                    setUfs(ufsData.data);
                }
            } catch (error) {
                console.error("Erro ao buscar UFs:", error);
                setToast({
                    message: "Erro ao buscar as UFs. Tente novamente.",
                    type: "error",
                });
            }
        };

        if (isOpen) {
            fetchUfs();
        }
    }, [isOpen]);

    useEffect(() => {
        const cpfCnpjLength = cpfCnpj.replace(/\D/g, '').length;
        setShowInscricaoEstadual(cpfCnpjLength >= 14);
    }, [cpfCnpj]);

    const handleUfChange = async (e) => {
        const selectedUf = e.target.value;
        setUf(selectedUf);
        setMunicipio('');

        if (selectedUf) {
            try {
                const municipiosData = await getMunicipiosUfId(selectedUf);
                if (Array.isArray(municipiosData.data)) {
                    setMunicipios(municipiosData.data);
                }
            } catch (error) {
                console.error('Erro ao buscar municípios:', error);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const Newcelular = celular.replace(/\D/g, '');
        const clienteData = {
            nome: nome.toUpperCase(),
            cpfCnpj: cpfCnpj.replace(/\D/g, ''),
            inscricaoEstadual: showInscricaoEstadual ? inscricaoEstadual : null,
            logradouro: logradouro.toUpperCase(),
            numero,
            bairro: bairro.toUpperCase(),
            municipio: municipio,
            celular: Newcelular,
            uf: uf
        };

        try {
            const response = await addCliente(clienteData);
            setToast({ message: "Cliente cadastrado com sucesso!", type: "success" });
            setTimeout(() => {
                onSuccess(response.data);
                onClose();
            }, 1500);
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Erro ao cadastrar cliente.";
            setToast({ message: errorMessage, type: "error" });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-full sm:max-w-xl px-4 sm:px-6 py-6 relative overflow-y-auto max-h-[90vh]">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-2xl font-bold"
                    onClick={onClose}
                >
                    &times;
                </button>
                <h2 className="text-xl font-semibold mb-4">Cadastro de Cliente</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block font-medium mb-1">Nome*</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={nome}
                            onChange={(e) => setNome(e.target.value.toUpperCase())}
                            required
                            maxLength="150"
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block font-medium mb-1">CPF / CNPJ*</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={cpfCnpjMask(cpfCnpj)}
                                onChange={(e) => setCpfCnpj(e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label className="block font-medium mb-1">Celular</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={celular}
                                onChange={(e) => setCelular(formatarCelular(e.target.value))}
                            />
                        </div>
                    </div>

                    {showInscricaoEstadual && (
                        <div>
                            <label className="block font-medium mb-1">Inscrição Estadual</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={inscricaoEstadual}
                                onChange={(e) => setInscricaoEstadual(e.target.value)}
                                maxLength="20"
                            />
                        </div>
                    )}

                    <div>
                        <label className="block font-medium mb-1">Logradouro</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={logradouro}
                            onChange={(e) => setLogradouro(e.target.value.toUpperCase())}
                            maxLength="100"
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block font-medium mb-1">Número</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={numero}
                                onChange={(e) => setNumero(e.target.value)}
                                maxLength="20"
                            />
                        </div>
                        <div>
                            <label className="block font-medium mb-1">Bairro</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={bairro}
                                onChange={(e) => setBairro(e.target.value)}
                                maxLength="100"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block font-medium mb-1">UF*</label>
                            <select
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={uf}
                                onChange={handleUfChange}
                                required
                            >
                                <option value="">Selecione</option>
                                {ufs.map((uf) => (
                                    <option key={uf.id} value={uf.codIBGE}>
                                        {uf.nome}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label className="block font-medium mb-1">Município*</label>
                            <select
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={municipio}
                                onChange={(e) => setMunicipio(e.target.value)}
                                required
                                disabled={!uf}
                            >
                                <option value="">Selecione</option>
                                {municipios.map((mun) => (
                                    <option key={mun.id} value={mun.id}>
                                        {mun.nome}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 mt-4">
                        <button
                            type="button"
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                        >
                            Salvar
                        </button>
                    </div>
                </form>
                {toast.message && <Toast type={toast.type} message={toast.message} />}
            </div>
        </div>
    );
};

export default CadClienteSimpl;